import { inject, Injectable } from '@angular/core';
import { SessionStorageService } from '../session-storage/session-storage.service';
import axios, { AxiosRequestConfig, AxiosError } from 'axios';
import { environment } from '../../../../environments/environment';
import { GetDownloadResourceListModel } from '../../models/get-download-resource-list/get-download-resource-list.model';
import { Platform } from '@angular/cdk/platform';

@Injectable({
  providedIn: 'root'
})
export class DownloadResourcesService {

  private platform = inject(Platform);
  private sessionStorageService = inject(SessionStorageService);

  constructor() { }

  async getDownloadResourceCategoryList() {
    const API_URL: string = environment.baseUrl + environment.apis.getDownloadResourceCategory;

    const REQUEST_CONFIG: AxiosRequestConfig = {
      method: 'POST',
      maxBodyLength: Infinity,
      url: API_URL,
      headers: {
        'Content-Type': 'application/json',
        'Authorization': this.sessionStorageService.getCurrentUserAuthToken()
      },
      data: {}
    }

    return await axios.request(REQUEST_CONFIG)
      .then((httpResponse) => {
        return JSON.stringify(httpResponse);
      })
      .catch((error) => {
        throw new AxiosError(error.response.data, error.status);
      });
  }

  async getDownloadResourceList(resourceCategoryId: number) {
    const API_URL: string = environment.baseUrl + environment.apis.getDownloadResourcelist;

    const REQUEST_CONFIG: AxiosRequestConfig = {
      method: 'POST',
      maxBodyLength: Infinity,
      url: API_URL,
      headers: {
        'Content-Type': 'application/json',
        'Authorization': this.sessionStorageService.getCurrentUserAuthToken()
      },
      data: {
        'resourcecategoryid': resourceCategoryId
      }
    };

    return await axios.request(REQUEST_CONFIG)
      .then((httpResponse) => {
        return JSON.stringify(httpResponse);
      })
      .catch((error) => {
        throw new AxiosError(error.response.data, error.status);
      });
  }

  async downloadResourceFile(resourceId: number, filename: string) {
    const API_URL: string = environment.baseUrl + environment.apis.getResourceFileById + `/${resourceId}`;
    const REQUEST_CONFIG: AxiosRequestConfig = {
      method: 'GET',
      maxBodyLength: Infinity,
      url: API_URL,
      responseType: 'blob',
      headers: {
        'Authorization': this.sessionStorageService.getCurrentUserAuthToken()
      }
    };
    await axios.request(REQUEST_CONFIG)
      .then((response) => {
        const blob = new Blob([response.data]);
        const objectUrl = URL.createObjectURL(blob);

        const a = document.createElement('a');
        a.href = objectUrl;
        a.download = filename;
        a.click();

        URL.revokeObjectURL(objectUrl);
      })
      .catch(error => {
        console.error('Download error:', error);
      });
  }

  async printPdf(resourceId: number) {
    const API_URL: string = environment.baseUrl + environment.apis.getResourceFileById + `/${resourceId}`;
    const REQUEST_CONFIG: AxiosRequestConfig = {
      method: 'GET',
      maxBodyLength: Infinity,
      url: API_URL,
      responseType: 'blob',
      headers: {
        'Authorization': this.sessionStorageService.getCurrentUserAuthToken()
      }
    };
    await axios.request(REQUEST_CONFIG)
      .then(response => {
        const pdfBlob = new Blob([response.data], {
          type: 'application/pdf'
        });

        const blobUrl = URL.createObjectURL(pdfBlob);

        if (this.platform.ANDROID || this.platform.IOS) {
          window.open(blobUrl, "_blank");
          return
        }

        const iframe = document.createElement('iframe');
        iframe.style.display = 'none';
        iframe.src = blobUrl;

        document.body.appendChild(iframe);

        iframe.onload = () => {
          iframe.contentWindow?.focus();
          iframe.contentWindow?.print();
        };
      }).catch(error => {
        console.error('PDF print error:', error);
      });
  }

}
